/**
 * ClubReceipts — historia paragonów członka (lista ze statusami).
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { clubApi } from './clubApi';

const STATUS_LABEL = {
  pending: 'Weryfikacja',
  approved: 'Zatwierdzony',
  rejected: 'Odrzucony',
};

const LOCATION_LABEL = {
  nowysacz: '🏔️ Nowy Sącz',
  krakow: '🏰 Kraków',
  grodek: '🌊 Gródek',
};

const formatDate = (iso) => {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    return d.toLocaleDateString('pl-PL', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch { return iso; }
};

export default function ClubReceipts() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    clubApi.get('/receipts/mine')
      .then((r) => setItems(r.data.receipts))
      .catch((e) => setError(e?.response?.data?.detail || 'Błąd ładowania'));
  }, []);

  return (
    <div className="club-shell">
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
        <button
          onClick={() => navigate('/mrjerryclub/dashboard')}
          style={{
            width: 36, height: 36, borderRadius: 10, background: 'rgba(255,255,255,0.05)',
            border: '1px solid var(--club-border-soft)', color: 'var(--club-text)',
            cursor: 'pointer', fontSize: 18,
          }}
        >‹</button>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, color: 'var(--club-text)' }}>Moje paragony</div>
          <div style={{ fontSize: 12, color: 'var(--club-text-muted)' }}>Historia i status</div>
        </div>
      </div>

      {error && <div className="club-alert club-alert-error">⚠️ {error}</div>}

      {items === null ? (
        <div className="club-loading">
          <div className="club-loading-spinner" />
        </div>
      ) : items.length === 0 ? (
        <div className="club-card" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 36, marginBottom: 12 }}>🧾</div>
          <div style={{ fontSize: 14, marginBottom: 16, color: 'var(--club-text)' }}>
            Brak paragonów. Dodaj pierwszy i zgarnij 50 pkt bonusu!
          </div>
          <button
            className="club-btn club-btn-primary"
            onClick={() => navigate('/mrjerryclub/dodaj-paragon')}
            data-testid="club-receipts-empty-cta"
          >
            📸 Dodaj paragon
          </button>
        </div>
      ) : (
        <div data-testid="club-receipts-list">
          {items.map((r) => (
            <div key={r.id} className="club-receipt-row" data-testid={`club-receipt-${r.id}`}>
              <div className="club-receipt-icon">🧾</div>
              <div className="club-receipt-body">
                <div className="club-receipt-title">
                  {r.amount.toFixed(2)} zł
                  {r.status === 'approved' && r.points_awarded > 0 && (
                    <span style={{ color: 'var(--club-gold)', marginLeft: 8 }}>+{r.points_awarded} pkt</span>
                  )}
                </div>
                <div className="club-receipt-meta">
                  {LOCATION_LABEL[r.location] || r.location} · {formatDate(r.visit_date)}
                </div>
                {r.rejection_reason && (
                  <div className="club-receipt-meta" style={{ color: 'var(--club-danger)' }}>
                    Powód: {r.rejection_reason}
                  </div>
                )}
              </div>
              <div className={`club-status-badge club-status-${r.status}`}>
                {STATUS_LABEL[r.status] || r.status}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
